import { Tooltip } from "@heroui/react";
import { t } from "@lingui/core/macro";
import { BadgeCheck } from "lucide-react";

/**
 * Marks a customer that is linked to an active marketplace (GlobalCustomer)
 * account. Such customers own their identity/contact fields through the
 * marketplace app, so those fields are read-only in the dashboard.
 *
 * Rendered as a small Globe icon with an explanatory hover tooltip; intended to
 * sit inline next to a customer's name across the dashboard (list, detail
 * header, pickers, merge, edit modal).
 */
export const GlobalCustomerIndicator = ({
  size = 16,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <Tooltip content={t`Osebne podatke ureja stranka sama.`} placement="top">
      <span
        className={`text-primary inline-flex shrink-0 items-center ${className ?? ""}`}
        aria-label={t`Stranka platforme`}
        data-identifier="global-customer-indicator"
      >
        <BadgeCheck size={size} aria-hidden />
      </span>
    </Tooltip>
  );
};
